import { gql } from '@/features/graphql/generated'

export const CartContainerItemFragment = gql(/* GraphQL */ `
    fragment CartContainerItem on CartContainerItem {
        uuid
        container {
            uuid
            internalName
            price {
                amount
                currency
            }
        }
        quantity
        totalPrice {
            amount
            currency
        }
    }
`)
